
import {mapState} from 'pinia'
import useApplicationStore from "../stores/application_module";
export default {
    data: function () {
        return {
            pageConfig: {},
            merchant_hierarchy_template_external_id: {},
            field_length: {
                phone_number_length: {
                    default : {
                        min: 10,
                        max: 10
                    },
                    'IRL': {
                        min: 8,
                        max: 10
                    },
                    'POL': {
                        min: 9,
                        max: 10
                    },
                    'GBR': {
                        min: 10,
                        max: 10
                    },
                    'SWE': {
                        min: 8,
                        max: 12
                    },
                    'NOR': {
                        min: 8,
                        max: 12
                    },
                    'DEU': {
                        min: 9,
                        max: 15
                    }
                },
                reg_number_length: {
                    default : {
                        min: 8,
                        max: 15
                    },
                    'IRL': {
                        min: 6,
                        max: 15
                    },
                    'GBR': {
                        min: 8,
                        max: 15
                    },
                    'SWE': {
                        min: 10,
                        max: 10
                    },
                    'NOR': {
                        min: 9,
                        max: 9
                    },
                    'DEU': {
                        min: 8,
                        max: 12
                    }
                },
                other_tax_id_length: {
                    default : {
                        min: 8,
                        max: 15
                    },
                    'IRL': {
                        min: 8,
                        max: 9
                    },
                },
                trade_name_length: {
                    default : {
                        min: 1,
                        max: 255
                    },
                },
                legal_name_length: {
                    default : {
                        min: 1,
                        max: 255
                    },
                },
                bic: {
                    default : {
                        min: 8,
                        max: 11
                    },
                },
                postcode_length: {
                    default: {
                        min: 5,
                        max: 10
                    },
                    'IRL': {
                        min: 5,
                        max: 10
                    },
                    'GBR': {
                        min: 5,
                        max: 10
                    },
                    'POL': {
                        min: 6,
                        max: 6
                    },
                    'SWE': {
                        min: 5,
                        max: 5
                    },
                    'NOR': {
                        min: 4,
                        max: 4
                    },
                    'DEU': {
                        min: 5,
                        max: 5
                    },
                    'AUT': {
                        min: 4,
                        max: 4
                    },
                    'CHE': {
                        min: 4,
                        max: 4
                    },
                },
                street_name_length: {
                    default : {
                        min: 1,
                        max: 40
                    },
                },
                house_name_length: {
                    default : {
                        min: 1,
                        max: 40
                    },
                },
                city_name_length: {
                    default : {
                        min: 1,
                        max: 35
                    },
                },
                locality_length: {
                    default : {
                        min: 1,
                        max: 40
                    },
                },
                first_name_length: {
                    default : {
                        min: 1,
                        max: 20
                    },
                },
                flat_number_length: {
                    default : {
                        min: 1,
                        max: 30
                    },
                },
                sort_code: {
                    default: {
                        min: 6,
                        max: 6,
                    },
                    'SWE': {
                        min: 4,
                        max: 5,
                    },
                    'NOR': {
                        min: 1,
                        max: 4,
                    },
                    'DEU': {
                        min: 6,
                        max: 7,
                    }
                },
                iban: {
                    default: {
                        min: 15,
                        max: 31,
                    },
                    'POL': {
                        min: 28,
                        max: 28,
                    },
                    'SWE': {
                        min: 15,
                        max: 34,
                    },
                    'DEU': {
                        min: 22,
                        max: 22,
                    },
                },
                account_number: {
                    default: {
                        min: 8,
                        max: 8,
                    },
                    'SWE': {
                        min: 7,
                        max: 10,
                    },
                    'NOR': {
                        min: 7,
                        max: 7,
                    },
                    'DEU': {
                        min: 15,
                        max: 31,
                    }
                },
                vat_number_length: {
                    default : {
                        min: 1,
                        max: 15
                    },
                    'POL': {
                        min: 10,
                        max: 10
                    },
                    'SWE': {
                        min: 10,
                        max: 12
                    },
                    'DEU': {
                        min: 9,
                        max: 12
                    },
                }
            },
            iso3UseBankIdPrincipalVerify: ['SWE', 'NOR'],
            intermediary_by_business_type: {
                // If country's iso3 exists, business_type e.g. "S" must be in the array to have intermediary owners
                // If not, business type must not be in the forbidden list to have intermediary owners
                'SWE': ['GP', "LP", "PL", "L"],
                'NOR': ['GP', "LP", "PL", "L"],
                forbidden: ["ST"],
            },
            allow_country_code: ['752', '578'],
        };
    },
    mounted: function () {
        if (!!this.pageConfig && Object.values(this.pageConfig).length > 0) {
            this.runPageConfig(this.pageConfig);
        }
    },
    computed: {
        ...mapState( useApplicationStore,{
            page_configuration: 'page_configuration',
            page_config_id: 'page_config_id',
            merchant_hierarchy_configuration_templates: 'merchant_hierarchy_configuration_templates',
            user: 'user',
        }),
        page_config() {
            // let page_config_id = this.merchant_hierarchy_configuration_templates[this.merchant_hierarchy_template_external_id]['page_config_external_id'];

            let page_config_id = this.page_config_id;

            if (this.page_configuration.hasOwnProperty(page_config_id)) {
                return this.page_configuration[page_config_id];
            }

            return [];
        },
        baseCountryCode: function(){
            let alliance = (!!this.user && this.user.hasOwnProperty('alliance')) ? this.user.alliance : null;
            let partner = (!!this.user && this.user.hasOwnProperty('partner')) ? this.user.partner : null;

            if (partner && partner.hasOwnProperty('contact_country')) {
                return partner.contact_country;
            }
            else if (alliance && alliance.hasOwnProperty('contact_country')) {
                return alliance.contact_country;
            }
            else {
                return '-';
            }
        },
        basePhoneCode: function(){
            let alliance = (!!this.user && this.user.hasOwnProperty('alliance')) ? this.user.alliance : null;
            let partner = (!!this.user && this.user.hasOwnProperty('partner')) ? this.user.partner : null;

            if (partner && partner.hasOwnProperty('default_phone_code')) {
                return partner.default_phone_code;
            }
            else if(alliance && alliance.hasOwnProperty('contact_phone_code')) {
                return alliance.contact_phone_code;
            }
            else {
                return '-';
            }
        },
        canUseBankIdVerify: function (){
            let vm = this;

            //check workflow
            if (this.parameters.hasOwnProperty('APPLICATION_PROCESS_ACTIONS_CHECK') && !!this.parameters.APPLICATION_PROCESS_ACTIONS_CHECK) {
                let workflow_actions = this.parameters.APPLICATION_PROCESS_ACTIONS_CHECK;
                let bank_id_workflow_action_exist = workflow_actions.BANK_ID_VERIFICATION === true;

                if (!bank_id_workflow_action_exist) {
                    return false;
                }

                let iso3 = vm.getIso3FromCountryCode(vm.baseCountryCode)
                let country_is_valid = this.iso3UseBankIdPrincipalVerify.includes(iso3);

                return !!bank_id_workflow_action_exist && !!country_is_valid;
            }

            return false;
        },
        reversedYesNoOption: function() {
            let yes_no_param = this.parameters && this.parameters.hasOwnProperty('YES_NO_OPTIONS') ?
                    this.parameters.YES_NO_OPTIONS.slice() : [],
                reversed_yes_no = yes_no_param.map((param) => {
                    let bufferParam = JSON.parse(JSON.stringify(param));
                    if (param.id === '0' || param.value === '0') {
                        bufferParam.id = '1';
                        bufferParam.value = '1';
                    } else if (param.id === '1' || param.value === '1') {
                        bufferParam.id = '0';
                        bufferParam.value = '0';
                    }

                    return bufferParam;
                });

            // console.log('reversedYesNoOption :=> ', this.parameters.YES_NO_OPTIONS)
            // console.log('reversedYesNoOption reverse :=> ', reversed_yes_no)

            return reversed_yes_no
        },
        canShowVATValidateButton: function () {
            if (this.baseCountryCode === '276') { // Germany doesn't validate VAT
                return false;
            }
            return true;
        },
    },
    methods: {
        //get phone number length by iso3Code
        getPhoneNoMinLengthByIso3: function(iso3) {
            if( this.field_length.phone_number_length.hasOwnProperty(iso3) )
            {
                return this.field_length.phone_number_length[iso3].min
            }
            else
            {
                return this.field_length.phone_number_length.default.min
            }

        },
        getPhoneNoMaxLengthByIso3: function(iso3) {
            if( this.field_length.phone_number_length.hasOwnProperty(iso3) )
            {
                return this.field_length.phone_number_length[iso3].max
            }
            else
            {
                return this.field_length.phone_number_length.default.max
            }

        },
        getRegNoFieldLengthByIso3: function(iso3, option) {
            if( this.field_length.reg_number_length.hasOwnProperty(iso3) && ( option.includes('max') || option.includes('min') ) )
            {
                return this.field_length.reg_number_length[iso3][option]
            }
            else if( option.includes('max') || option.includes('min') )
            {
                return this.field_length.reg_number_length.default[option]
            }
            else
            {
                return 15
            }

        },
        getFirstNameMaxLengthByIso3: function(option) {
            let has_valid_option = ['max', 'min'].includes(option);

            if (has_valid_option) {
                return this.field_length.first_name_length.default[option];
            }
            else {
                return 20;
            }
        },
        getOtherTaxIdFieldLengthByIso3: function(iso3, option='max') {
            if (this.field_length.other_tax_id_length) {
                //match iso3 country
                if (this.field_length.other_tax_id_length.hasOwnProperty(iso3)) {
                    if (this.field_length.other_tax_id_length[iso3].hasOwnProperty(option)) {
                        return this.field_length.other_tax_id_length[iso3][option];
                    }
                }
                //match default
                else if (this.field_length.other_tax_id_length.hasOwnProperty('default')) {
                    if (this.field_length.other_tax_id_length['default'].hasOwnProperty(option)) {
                        return this.field_length.other_tax_id_length['default'][option];
                    }
                }
            }
            //no match
            return 15;
        },
        getTradeNameFieldLengthByIso3: function(iso3, option='max') {
            if (this.field_length.trade_name_length) {
                //match iso3 country
                if (this.field_length.trade_name_length.hasOwnProperty(iso3)) {
                    if (this.field_length.trade_name_length[iso3].hasOwnProperty(option)) {
                        return this.field_length.trade_name_length[iso3][option];
                    }
                }
                //match default
                else if (this.field_length.trade_name_length.hasOwnProperty('default')) {
                    if (this.field_length.trade_name_length['default'].hasOwnProperty(option)) {
                        return this.field_length.trade_name_length['default'][option];
                    }
                }
            }
            //no match
            return 255;
        },
        getLegalNameFieldLengthByIso3: function(iso3, option='max') {
            if (this.field_length.legel_name_length) {
                //match iso3 country
                if (this.field_length.legel_name_length.hasOwnProperty(iso3)) {
                    if (this.field_length.legel_name_length[iso3].hasOwnProperty(option)) {
                        return this.field_length.legel_name_length[iso3][option];
                    }
                }
                //match default
                else if (this.field_length.legel_name_length.hasOwnProperty('default')) {
                    if (this.field_length.legel_name_length['default'].hasOwnProperty(option)) {
                        return this.field_length.legel_name_length['default'][option];
                    }
                }
            }
            //no match
            return 255;
        },
        getVatFieldLengthByIso3: function(iso3, option) {
            if( this.field_length.vat_number_length.hasOwnProperty(iso3) && ( option.includes('max') || option.includes('min') ) )
            {
                return this.field_length.vat_number_length[iso3][option];
            }
            else if( option.includes('max') || option.includes('min') )
            {
                return this.field_length.vat_number_length.default[option];
            }
            else
            {
                return 15;
            }
        },
        isVATFieldCompulsoryFromCountryCode: function (countryCode) {
            // don't show "VAT Registered?" confirmation if it is Sweden Alliance.
            // VAT (Company Registration Number) is compulsory for SWEDEN
            return false;
        },
        canHaveIntermediaryByIso3: function (iso3, business_type) {
            if (this.intermediary_by_business_type.hasOwnProperty(iso3)) {
                return this.intermediary_by_business_type[iso3].includes(business_type);
            } else {
                return !this.intermediary_by_business_type.forbidden.includes(business_type);
            }
        },
        getVATLabelFromCountryCode: function (countryCode) {
            return this.lang('tax_id');
        },
        getHouseNameLabelFromCountryCode: function (countryCode) {
            if(this.allow_country_code.includes(countryCode)){
                return this.lang('field_street_line_2');
            }
            return this.lang('field_building_name');
        },
        getHouseNumberLabelFromCountryCode: function (countryCode) {
            if(this.allow_country_code.includes(countryCode)){
                return this.lang('field_street_number');
            }
            return this.lang('field_building_no');
        },
        getStreetLabelFromCountryCode: function (countryCode) {
            return this.lang('field_street');
        },
        getCityLabelFromCountryCode: function (countryCode) {
            if(this.allow_country_code.includes(countryCode)){
                return this.lang('field_city');
            }
            return this.lang('field_town_city');
        },
        getBICFieldLengthByIso3: function(iso3, option) {
            if( this.field_length.bic.hasOwnProperty(iso3) && ( option.includes('max') || option.includes('min') ) )
            {
                return this.field_length.bic[iso3][option]
            }
            else if( option.includes('max') || option.includes('min') )
            {
                return this.field_length.bic.default[option]
            }
            else
            {
                return 15
            }

        },
        checkCountryAddress: function (code, tenant_country_code) {
            if (tenant_country_code === 276) {
                let allow_for_germany_codes = ['756','40','276'];
                return allow_for_germany_codes.includes(code);
            }
            return false;
        },
        onCountryCodeChange: function (val, element) {
            let vm = this;
            $(`#${element}`).data('rule-country_postcode_validator', val);
            let min = this.getPostCodeFieldLengthByIso3(vm.getIso3FromCountryCode(val), 'min');
            let max = this.getPostCodeFieldLengthByIso3(vm.getIso3FromCountryCode(val), 'max');
            $(`#${element}`).attr('minlength', min);
            $(`#${element}`).attr('maxlength', max);
        },
        getPostCodeFieldLengthByIso3: function(iso3, option, no_country=false) {
            if( this.field_length.postcode_length.hasOwnProperty(iso3) && ( option.includes('max') || option.includes('min') ) )
            {
                return this.field_length.postcode_length[iso3][option]
            }
            else if( option.includes('max') || option.includes('min') )
            {
                return this.field_length.postcode_length.default[option];
            }
            else
            {
                return 15
            }

        },
        getStreetNameFieldLength: function(option) {
            if (option && option.includes('max') || option.includes('min')) {
                return this.field_length.street_name_length.default[option]
            }
            else {
                return 40;
            }
        },
        getHouseNameFieldLength: function(option) {
            if (option && option.includes('max') || option.includes('min')) {
                return this.field_length.house_name_length.default[option]
            }
            else {
                return 40;
            }
        },
        getCityFieldLength: function(option) {
            if (option && option.includes('max') || option.includes('min')) {
                return this.field_length.city_name_length.default[option]
            }
            else {
                return 35;
            }
        },
        getLocalityFieldLength: function(option) {
            if (option && option.includes('max') || option.includes('min')) {
                return this.field_length.locality_length.default[option]
            }
            else {
                return 40;
            }
        },
        getFlatNumberFieldLength: function(option) {
            if (option && option.includes('max') || option.includes('min')) {
                return this.field_length.flat_number_length.default[option]
            }
            else {
                return 30;
            }
        },
        getIso3FromPhoneCode: function(phone_code){
            let countries = !!this.parameters.PHONE_CODES ? this.parameters.PHONE_CODES : [];
            let iso3 = '';
            if (phone_code != '') {
                let entry = countries.find(obj => {
                    return !!obj.phone_code && obj.phone_code == phone_code
                });
                iso3 = !!entry ? entry.iso3 : ''
            }
            return iso3;
        },
        getMerchantCountryCode: function (country_code = null)
        {
            return country_code ? this.getIso3FromCountryCode(country_code):this.getIso3FromCountryCode(this.baseCountryCode)
        },
        getIso3FromCountryCode: function(country_code)
        {
            let country =  !!this.parameters && this.parameters.hasOwnProperty('COUNTRIES_PARAM') ? Object.values(this.parameters.COUNTRIES_PARAM).find(obj => {return obj.numcode === country_code}) : null

            if (country && country.hasOwnProperty('iso3') )
            {
                return country.iso3
            }
            else
            {
                return ''
            }

        },
        getCountryNumCodeFromIso3: function (country_iso3) {
            let countries = !!this.parameters.COUNTRIES_PARAM ? this.parameters.COUNTRIES_PARAM : [];
            let numcode = '';
            if (country_iso3 != '') {
                let entry = countries.find(obj => {
                    return !!obj.iso3 && obj.iso3 == country_iso3
                });
                numcode = !!entry ? entry.numcode : ''
            }
            return numcode;
        },
        getCountryCodeParams: function(entity_block, country_code_field_name='country_code')
        {
            let vm = this;
            let app_default_param_country_code = null;
            let country_params = [];
            if (!!vm.parameters && vm.npPropertyExistAndIsArray(vm.parameters, 'COUNTRIES_PARAM')) {
                country_params = Object.values(vm.parameters.COUNTRIES_PARAM);
            }
            //console.log('ten_app_default', vm.parameters.TENANT_APP_DEFAULTS_PARAM.filter(param => param.field_name === 'country_code'))
            if (!!vm.parameters && vm.npPropertyExistAndIsArray(vm.parameters, 'TENANT_APP_DEFAULTS_PARAM')) {
                app_default_param_country_code = vm.parameters.TENANT_APP_DEFAULTS_PARAM.filter(
                    param => param.field_name === country_code_field_name
                        && param.entity_block === entity_block
                        && param.selfboarding_readonly === '1');
                if (!!app_default_param_country_code && app_default_param_country_code.length > 0) {
                    let default_value = app_default_param_country_code[0].selfboarding_default_value;
                    if (!!default_value) {
                        //console.log('param overwrite to one')
                        return country_params.filter(country_code_param => country_code_param.id === default_value);
                    }
                }
            }

            return country_params;
        },
        getCurrencyCodeSymbol: function(cur_code=null) {
            if(!cur_code)
            {
                //default currency
                cur_code = "GBP"

                //init cur_code from alliance default cur
                let alliance = (!!this.user && this.user.hasOwnProperty('alliance')) ? this.user.alliance : null;
                let partner = (!!this.user && this.user.hasOwnProperty('partner')) ? this.user.partner : null;

                if (partner && partner.hasOwnProperty('default_currency')) {
                    cur_code = partner.default_currency;
                }
                else if(alliance && alliance.hasOwnProperty('default_currency')) {
                    cur_code = alliance.default_currency;
                }
            }

            //check symbol under currency-param
            if (this.parameters && this.parameters.hasOwnProperty('CURRENCIES_PARAM')) {
                let  keyed_currencies = this.parameters.CURRENCIES_PARAM;
                if (!!keyed_currencies && keyed_currencies[cur_code] && !!keyed_currencies[cur_code].currency_symbol) {
                    return keyed_currencies[cur_code].currency_symbol;
                }
            }

            return '£';
        },
        getSortCodeFieldLengthByIso3: function (iso3, option){
            if (this.field_length.sort_code.hasOwnProperty(iso3) && (option.includes('max') || option.includes('min'))) {
                return this.field_length.sort_code[iso3][option]
            } else if (option.includes('max') || option.includes('min')) {
                return this.field_length.sort_code.default[option]
            } else {
                return 6
            }
        },

        getAccountNumbereFieldLengthByIso3: function (iso3, option){
            if (this.field_length.account_number.hasOwnProperty(iso3) && (option.includes('max') || option.includes('min'))) {
                return this.field_length.account_number[iso3][option]
            } else if (option.includes('max') || option.includes('min')) {
                return this.field_length.account_number.default[option]
            } else {
                return 8
            }
        },
        getIbanFieldLengthByIso3: function (iso3, option){
            if (this.field_length.iban.hasOwnProperty(iso3) && (option.includes('max') || option.includes('min'))) {
                return this.field_length.iban[iso3][option]
            } else if (option.includes('max') || option.includes('min')) {
                return this.field_length.iban.default[option]
            } else {
                return 15
            }
        },
        getPageConfig(merchant_hierarchy_template_external_id) {
            let page_config_id = this.merchant_hierarchy_configuration_templates[merchant_hierarchy_template_external_id]['page_config_external_id'];

            if (this.page_configuration.hasOwnProperty(page_config_id)) {
                return this.page_configuration[page_config_id];
            }

            return [];
        },
        runPageConfig(pageConfig, pageObject) {
            if (!pageObject) {
                pageObject = this;  //only when pass pagObject which is an anonymous component, it is itself.
            }
            let removeElement = (element) => {
                if (!!pageObject.$refs[element.id]) {
                    if (element.attribute.type === 'field' || element.attribute.type === 'phone' || element.attribute.type === 'sub_block') {
                        let DOMElement;
                        DOMElement = pageObject.$refs[element.id]['$el'];
                        if (!!DOMElement) {
                            if(!DOMElement.childNodes.length && document.getElementById(element.id)) {
                                DOMElement.nextElementSibling?.remove();
                            } else {
                                DOMElement.remove();
                            }
                        } else {
                            let InnerDOMElement = pageObject.$refs[element.id];

                            if (!!InnerDOMElement) {
                                //this fixes issues with block that appear twice like on address finder fields
                                if (InnerDOMElement.length > 0) {
                                    InnerDOMElement.forEach(domEl => $(domEl['$el']).remove())
                                } else {
                                    InnerDOMElement.remove();
                                }
                            }
                        }
                    } else if (element.attribute.type === 'array_field' || element.attribute.type === 'phone_array_field' ) {
                        let DOMElements = pageObject.$refs[element.id];
                        DOMElements.forEach(function (obj) {
                            let DOMElement = obj['$el'];
                            if (!!DOMElement) {
                                DOMElement.remove();
                            } else {
                                obj.remove();
                            }
                        });
                    } else {
                        let DOMElement;
                        DOMElement = pageObject.$refs[element.id];
                        if (!!DOMElement) {
                            //this fixes issues with block that appear twice like on principal page
                            if (Array.isArray(DOMElement)) {
                                DOMElement.forEach(element => element.remove())
                            } else {
                                if(DOMElement.length != 0 || this.objectIsNotEmpty(DOMElement)) {
                                    DOMElement.remove();
                                }
                            }
                        }
                    }
                }
            };

            let blockRender = (block) => {
                let elements = (block.hasOwnProperty('elements') && !!block.elements) ? Object.values(block.elements) : [];

                elements.forEach(element => {
                    const is_required = (!!element.attribute.is_required && (element.attribute.is_required === 'Y' || element.attribute.is_required === 'M'));

                    if (element.attribute.type === 'field') {
                        if (element.attribute.selected === 'Y') {
                            if (!!pageObject.$refs[element.id]) {
                                let DOMElementComp = pageObject.$refs[element.id];
                                if (Array.isArray(DOMElementComp) && DOMElementComp.length > 0) {
                                    DOMElementComp = DOMElementComp[0];
                                }
                                DOMElementComp.page_config_required = is_required;
                                if (DOMElementComp.$children && DOMElementComp.$children.length > 0) {
                                    DOMElementComp.$children.forEach(childElement => {
                                        childElement.page_config_required = is_required;
                                    });
                                }
                            }
                        } else {
                            removeElement(element);
                        }
                    }
                    else if (element.attribute.type === 'phone') {
                        if (element.attribute.selected === 'Y') {
                            if (!!pageObject.$refs[element.id]) {
                                let phone_code = element.id + '_code';
                                let phone_number = element.id + '_no';
                                let phoneCode = pageObject.$refs.hasOwnProperty(phone_code) ? pageObject.$refs[element.id + '_code'] : undefined;
                                let phoneNumber = pageObject.$refs.hasOwnProperty(phone_number) ? pageObject.$refs[element.id + '_no'] : undefined;
                                if(!!phoneCode) {
                                    phoneCode.page_config_required = is_required;
                                }
                                if(!!phoneNumber) {
                                    phoneNumber.page_config_required = is_required;
                                }
                            }
                        } else {
                            removeElement(element);
                        }
                    }
                    else if (element.attribute.type === 'array_field' || element.attribute.type === 'phone_array_field') {
                        if (element.attribute.selected === 'Y') {
                            if (!!pageObject.$refs[element.id]) {
                                let arrayFields = pageObject.$refs[element.id];
                                if(element.attribute.type === 'phone_array_field') {
                                    arrayFields.forEach(function(ref, index) {
                                        let phone_code = element.id + '_code';
                                        let phone_number = element.id + '_no';
                                        let phoneCode = pageObject.$refs.hasOwnProperty(phone_code) ? pageObject.$refs[element.id + '_code'][index] : undefined;
                                        let phoneNumber = pageObject.$refs.hasOwnProperty(phone_number) ? pageObject.$refs[element.id + '_no'][index] : undefined;
                                        if(!!phoneCode) {
                                            phoneCode.page_config_required = is_required;
                                        }
                                        if(!!phoneNumber) {
                                            phoneNumber.page_config_required = is_required;
                                        }
                                    })
                                } else {

                                    // if(Array.isArray(arrayFields)){
                                        arrayFields.forEach(function(ref) {
                                            ref.page_config_required = is_required;
                                            if (ref.$children && ref.$children.length > 0) {
                                                ref.$children.forEach(childElement => {
                                                    childElement.page_config_required = is_required;
                                                });
                                            }
                                        })
                                    // }else{
                                    //     arrayFields.page_config_required = is_required;
                                    // }

                                }
                            }
                        } else {
                            removeElement(element);
                        }
                    } else if (element.attribute.type === 'sub_block') {
                        if (element.attribute.selected === 'Y') {
                            blockRender(element);
                        } else {
                            removeElement(element)
                        }
                    }
                });
            };

            let blocksRender = (pageConfig) => {
                if (!!pageConfig) {
                    let blocks = pageConfig.hasOwnProperty('blocks') ? Object.values(pageConfig.blocks) : [];
                    blocks.forEach(block => {
                        if (block.attribute.selected === 'Y') {
                            blockRender(block);
                        } else {
                            removeElement(block);
                        }
                    });
                }
            };

            blocksRender(pageConfig);
        },
        checkConfig: function(check_type=null, config=null, template_name=null, block_name=null, element_name=null){
            //console.log('Independent checkConfig')
            let checks = ['IS_REQUIRED', 'IS_SELECTED']

            const check = (attribute) => {
                if(check_type === 'IS_REQUIRED')
                {
                    return attribute.is_required === 'Y'
                }
                else if(check_type === 'IS_SELECTED'){
                    return attribute.selected === 'Y'
                }
                return false
            }

            if(check_type && checks.find(e => e === check_type)) {
                let template = config && template_name ? config[template_name] : null
                let blocks = template && template.hasOwnProperty('blocks') ? template['blocks'] : null
                let block = blocks && blocks.hasOwnProperty(block_name) ? blocks[block_name] : null
                let elements = block && block.hasOwnProperty('elements') ? block['elements'] : null
                let element = elements && element_name ? elements[element_name] : null

                if (element && element.hasOwnProperty('attribute')) {
                    return check(element.attribute)
                } else if (block && element.hasOwnProperty('attribute')) {
                    return check(block.attribute)
                }
            }

            return false

        },
        formatAddress: function (address, single_line = false) {
            let fullAddress = '';
            let is_address = false;
            let comma = '';
            let separator = '';
            if (!single_line) {
                comma = ',';
                separator = '<br/>';
            } else {
                separator = ',&nbsp';
            }

            for (let address_line in address) {
                if (address.hasOwnProperty(address_line) && address[address_line] !== '') {
                    is_address = true;
                }
            }
            if (is_address) {
                //Germany-276, Austria-40, Switzerland-756
                if ([ '276', '40', '756'].includes(address.country_code))
                {
                    fullAddress += address.street_line_1 === '' ? '' : address.street_line_1 + ' ';
                    fullAddress += address.house_number === '' ? '' : address.house_number + ' ';
                    fullAddress += address.house_name === '' ? '' : address.house_name + ' ';
                    fullAddress += fullAddress === '' ? '' : comma + separator;
                    fullAddress += address.city === '' ? '' : address.city + comma + separator;
                    fullAddress += address.county_code === '' ? '' : address.county_code + separator;
                    fullAddress += address.zip_code === '' ? '' : address.zip_code + separator;
                    fullAddress += address.country_code === '' || !address.hasOwnProperty('country_code') ? '' : this.formatCountry(address.country_code);
                    fullAddress = fullAddress === '' ? '-' : fullAddress;
                } else {
                    fullAddress += address.house_number === '' ? '' : address.house_number + ' ';
                    fullAddress += address.house_name === '' ? '' : address.house_name + ' ';
                    fullAddress += address.street_line_1 === '' ? '' : address.street_line_1 + comma + separator;
                    fullAddress += address.city === '' ? '' : address.city + comma + separator;
                    fullAddress += address.county_code === '' ? '' : address.county_code + separator;
                    fullAddress += address.zip_code === '' ? '' : address.zip_code + separator;
                    fullAddress += address.country_code === '' || !address.hasOwnProperty('country_code') ? '' : this.formatCountry(address.country_code);
                    fullAddress = fullAddress === '' ? '-' : fullAddress;
                }
            } else {
                fullAddress = "-";
            }
            return fullAddress;
        },
        formatNumber: function (number) {
            let num = parseFloat(this.vet(number));
            return num ? num.toLocaleString('en') : 0;
        },
        vet: function (value) {
            if (value && (typeof value !== "undefined")) return value;
            else return '-';
        },
        formatCompanyType: function (data) {
            const type = {'L': this.lang('limited'), 'ST': this.lang('non_limited')};
            return type.hasOwnProperty(data) ? type[data] : '-';
        },
        formatName: function (name) {
            var fullName = '';
            if (typeof name !== "undefined" || !isNull(name)) {
                fullName += name.tittle === '' ? '' : name.tittle + ' ';
                fullName += name.first_name === '' ? '' : name.first_name + ' ';
                fullName += name.middle_name === '' ? '' : name.middle_name + ' ';
                fullName += name.last_name === '' ? '' : name.last_name + ' ';
                fullName += name.suffix === '' ? '' : name.suffix;
                fullName = fullName === '' ? '-' : fullName;
            } else {
                fullName = "-";
            }
            return fullName;
        },
        objectIsNotEmpty: function (object) {
            for (var property in object) {
                if(object.hasOwnProperty(property)) {
                    return true;
                }
                else {
                    return false;
                }
            }
        },
        formatIndustryType: function (corporate_identification) {
            var industryInfo = '';
            if (typeof corporate_identification !== "undefined") {
                industryInfo += corporate_identification.sic_codes[0].code === '' ? '' : corporate_identification.sic_codes[0].code + '<br/>';
                industryInfo += corporate_identification.sic_codes[0].description === '' ? '' : corporate_identification.sic_codes[0].description + '<br/>';
                industryInfo += corporate_identification.business_activities === '' ? '' : corporate_identification.business_activities;
            } else {
                industryInfo = "-";
            }
            return industryInfo;
        },
        formatPrincipal: function (data) {
            let vm = this;
            return this.formatOptionType(vm.parameters, data, 'YES_NO_OPTIONS');
        },
        formatPosition: function (data) {
            let vm = this;
            return this.formatSelectType(vm.parameters, data, 'FD_OWNER_POSITION_PARAM');
        },
        formatCardAcceptanceMethod: function (data) {
            let vm = this;
            return this.formatSelectType(vm.parameters, data, 'CARD_ACCEPTANCE_METHODS');
        },
        formatBooleanOption: function (data) {
            if (!!data && data !== '-' && data !== '') {
                return this.formatOptionType(this.parameters, data, 'YES_NO_OPTIONS');
            }
            return '-';
        },
        formatReverseBooleanOption: function (data) {
            if (!!data && data !== '-' && data !== '') {
                let reverse_param = {
                    'YES_NO_OPTIONS': this.reversedYesNoOption
                };
                return this.formatOptionType(reverse_param, data, 'YES_NO_OPTIONS');
            }
            return this.lang('yes');
        },
        formatDirectionalOwnershipType: function (data) {
            if (!!data && data !== '-' && data !== '') {
                return this.formatOptionType(this.parameters, data, 'COMPANY_OWNERSHIP_TYPE');
            }
            return data;
        },
        formatVATApplied: function (data) {
            return this.formatOptionType(this.parameters, data, 'VAT_OPTIONS')
        },
        formatOtherVatTypes: function (data) {
            return this.formatOptionType(this.parameters, data, 'OTHER_TAX_NO_TYPE')
        },
        formatBusinessType: function (data) {
            if (!!data && data !== "") {
                let vm = this;
                return this.formatSelectType(vm.parameters, data, 'BUSINESS_TYPE_PARAM');
            }
            else {
                return '-';
            }
        },
        formatBusinessLevelOption: function (data) {
            let vm = this;
            return this.formatOptionType(vm.parameters, data, 'BUSINESS_LEVEL_OPTIONS');
        },
        formatPricingLevelOption: function (data) {
            let vm = this;
            return this.formatOptionType(vm.parameters, data, 'PRICING_LEVEL_OPTIONS');
        },
        formatBillingLevelOption: function (data) {
            let vm = this;
            return this.formatOptionType(vm.parameters, data, 'BILLING_LEVEL_OPTIONS');
        },
        formatMerchantHierarchyLevelOption: function (data) {
            if (!!data && data !== "") {
                let vm = this;
                return this.formatSelectType(vm.parameters, data, 'MERCHANT_HIERARCHY_TEMPLATE_LEVELS');
            }
            else {
                return '-';
            }
        },
        formatAddressOwnership: function (data) {
            if (!!data && data !== "") {
                let vm = this;
                return this.formatSelectType(vm.parameters, data, 'FD_ADDRESS_OWNERSHIP_PARAM');
            }
            else {
                return '-';
            }
        },
        formatCountry: function (data) {
            if (!!data && data !== "") {
                return this.formatSelectType(this.parameters, data, 'COUNTRIES_PARAM');
            }
            else {
                return '-';
            }
        },
        formatDate: function(data) {
            // Format the date according to the alliance or partner date requirement
            let tenant_format = $('body').data('date-format');
            if (typeof tenant_format === 'undefined') {
                tenant_format = 'ddmmyyyy';
            }
            if (!!data && data !== '') {
                return this.formatAlliancePartnerDate(this.parameters, data, tenant_format);
            }
            return data;
        },
        formatFundingCurrency: function (data) {
            if (!!data && data !== "") {
                return this.formatSelectType(this.parameters, data, 'FUNDING_CURRENCIES');
            }
            else {
                return '-';
            }
        },
        formatCounty: function (data) {
            let county = '-';
            if (!!data && data !== "") {
                county = this.formatSelectType(this.parameters, data, 'STATES_PARAM');
                return county !== '-' ? county : data; //so non-USA county will return their data
            }
            return county;
        },
        formatNationality: function (data) {
            if (!!data && data !== "") {
                return this.formatSelectType(this.parameters, data, 'NATIONALITIES');
            }
            else {
                return '-';
            }
        },
        formatSettlementMethod: function (data) {
            if (!!data && data !== "") {
                return this.formatSelectType(this.parameters, data, 'SETTLEMENT_METHODS');
            }
            else {
                return '-';
            }
        },
        formatCurrencyValue: function (value) {
            let data = !!value ? value.replaceAll(',', '') : '0';

            return this.formatNumberByLocale(data, 2, 'currency')
            // return `${this.getCurrencyCodeSymbol()}` + data;
        },
        formatPercentValue: function (value) {
            let data = !!value ? value : '0';
            return data + ' %';
        },
        formatOwmershipType: function (data) {
            if (!!data && data !== "") {
                return this.formatSelectType(this.parameters, data, 'FD_BUSINESS_TYPE_PARAM');
            } else {
                return '-';
            }
        },
        formatBusinessZone: function (data) {
            if (!!data && data !== "") {
                return this.formatSelectType(this.parameters, data, 'TIME_ZONES_PARAM');
            } else {
                return '-';
            }
        },
        formatBusinessCategory: function (data) {
            if (!!data && data !== "") {
                return this.formatSelectType(this.parameters, data, 'FD_BUSINESS_CATEGORY_PARAM');
            } else {
                return '-';
            }
        },
        formatIncorpState: function (data) {
            if (!!data && data !== "") {
                return this.formatSelectType(this.parameters, data, 'STATES_PARAM');
            } else {
                return '-';
            }
        },
        formatServiceContractId: function (data) {
            if (!!data && data !== "") {
                return this.formatSelectType(this.parameters, data, 'FD_SERVICE_CONTRACT_PARAM');
            } else {
                return '-';
            }
        },
        formatGroundFloor: function (data) {
            if (!!data && data !== "") {
                return this.formatSelectType(this.parameters, data, 'MP_GROUND_FLOOR');
            } else {
                return '-';
            }
        },
        formatYesNo: function (data) {
            if (!!data && data !== "") {
                data = data != 'N' ? '1' : '0';
                return this.formatBooleanOption(data);
            } else {
                return '-';
            }
        },
        formatMerchantOptions: function (data) {
            let vm = this;
            //console.log('data ', data);
            return this.formatOptionType(vm.parameters, data, 'MERCHANT_TYPE_OPTIONS');
        },
        formatAmexAgreementCode: function (data) {
            return this.formatSelectType(this.parameters, data, 'FD_AMEX_AGREEMENT_CODE_PARAM');
        },
        formatAmexMerchantType: function (data) {
            return this.formatSelectType(this.parameters, data, 'MERCHANT_TYPE_OPTIONS');
        },
        formatIrsStatus: function (data) {
            return this.formatSelectType(this.parameters, data, 'MP_AMEX_SETTLEMENT');
        },
        formatCurrency: function (data) {
            let vm = this;
            return this.formatSelectType(vm.parameters, data, 'CURRENCIES_PARAM');
        },
        formatAmexIndustryCode: function (data) {
            return this.formatSelectType(this.parameters, data, 'FD_AMEX_INDUSTRY_CODE_PARAM');
        },
        formatAccountTypes: function (data) {
            let account_types = '';
            if (this.objectIsNotEmpty(data)) {
                for (let datum of data) {
                    datum = this.lang(datum.toLowerCase())
                    account_types = account_types === '' ? datum : account_types + ', ' + datum;
                }
                return account_types;
            } else {
                return '-';
            }
        },
        formatMCC: function (data) {
            if (!!data && data !== "") {
                return this.formatSelectType(this.parameters, data, 'MCC_CODES_PARAM');
            }
            return '-';
        },
        formatBusinessSector: function (data) {
            if (!!data && data !== "") {
                return this.formatSelectType(this.parameters, data, 'BUSINESS_SECTORS_ALL');
            }
            return '-';
        },
        formatBuildingFloorNumber: function (data) {
            if (!!data && data !== "") {
                return this.formatSelectType(this.parameters, data, 'MP_NUMBER_OF_BUILDING_FLOORS')
            }
            return '-';
        },
        formatVisitationRequired: function (data) {
            if (!!data && data !== "") {
                return this.formatSelectType(this.parameters, data, 'MP_VISITATION_REQUIRED')
            }
            return '-';
        },
        formatBusinessLocation: function (data) {
            if (!!data && data !== "") {
                return this.formatSelectType(this.parameters, data, 'MP_BUSINESS_LOCATION')
            }
            return '-';
        },
        formatTinType: function (data) {
            if (!!data && data !== "") {
                return this.formatSelectType(this.parameters, data, 'MP_TIN_TYPE')
            }
            return '-';
        },
        formatTitle: function (data) {
            if (!!data && data !== "") {
                return this.formatSelectType(this.parameters, data, 'TITLES')
            }
            return '-';
        },
        formatPhoneCode: function (data) {
            if (!!data && data !== "") {
                return this.formatSelectType(this.parameters, data, 'PHONE_CODES')
            }
            return '-';
        },
        formatChainNumber: function (data){
            let vm = this;
            return this.formatOptionType(vm.parameters, data, 'CHAIN_NUMBER');
        },
        formatAmexSettlement: function (data) {
            if (!!data && data !== "") {
                return this.formatSelectType(this.parameters, data, 'MP_AMEX_SETTLEMENT')
            }
            return '-';
        },
        formatAutoSettle: function (data) {
            if (!!data && data !== "") {
                return this.formatSelectType(this.parameters, data, 'MP_AUTO_SETTLE')
            }
            return '-';
        },
        formatChargebackRetrievalsMail: function (data) {
            if (!!data && data !== "") {
                return this.formatSelectType(this.parameters, data, 'MP_CHARGEBACK_RETRIEVALS_MAIL')
            }
            return '-';
        },
        formatChipFlag: function (data) {
            if (!!data && data !== "") {
                return this.formatSelectType(this.parameters, data, 'MP_CHIP_FLAG')
            }
            return '-';
        },
        formatConvenienceFeeFunding: function (data) {
            if (!!data && data !== "") {
                return this.formatSelectType(this.parameters, data, 'MP_CONVENIENCE_FEE_FUNDING')
            }
            return '-';
        },
        formatDiscoverServiceType: function (data) {
            if (!!data && data !== "") {
                return this.formatSelectType(this.parameters, data, 'MP_DISCOVER_SERVICE_TYPE')
            }
            return '-';
        },
        formatAmexType: function (data) {
            if (!!data && data !== "") {
                return this.formatSelectType(this.parameters, data, 'MP_AMEX_TYPE')
            }
            return '-';
        },
        formatEarlyTerminationFee: function (data) {
            if (!!data && data !== "") {
                return this.formatSelectType(this.parameters, data, 'MP_EARLY_TERMINATION_FEE')
            }
            return '-';
        },
        submitPrevent: function() {

        },
        validateForm: function (form_selector) {
           const validator =  $(`${form_selector}`).validate({ focusInvalid: false });
           const validate_form = $(`${form_selector}`).valid();

           if (validator.numberOfInvalids()) {
                $('html, body').animate({
                    scrollTop: ($(validator.errorList[0].element).offset().top - 300)
                }, 2000);
            }

            return validate_form;
        },
        formatEquipmentBillingMethod: function (data) {
            if (!!data && data !== "") {
                return this.formatSelectType(this.parameters, data, 'MP_EQUIPMENT_BILLING_METHOD')
            }
            return '-';
        },
        formatFundingCut: function (data) {
            if (!!data && data !== "") {
                return this.formatSelectType(this.parameters, data, 'MP_FUNDING_CUT')
            }
            return '-';
        },
        formatPayeezy: function (data) {
            if (!!data && data !== "") {
                return this.formatSelectType(this.parameters, data, 'MP_PAYEEZY')
            }
            return '-';
        },
        formatSeasonalBusiness: function (data) {
            if (!!data && data !== "") {
                return this.formatSelectType(this.parameters, data, 'MP_SEASONAL_BUSINESS')
            }
            return '-';
        },
        formatSettlementFrequency: function (data) {
            if (!!data && data !== "") {
                return this.formatSelectType(this.parameters, data, 'MP_SETTLEMENT_FREQUENCY')
            }
            return '-';
        },
        formatShippingMethod: function (data) {
            if (!!data && data !== "") {
                return this.formatSelectType(this.parameters, data, 'MP_SHIPPING_METHOD')
            }
            return '-';
        },
        formatShipSuppliesTo: function (data) {
            if (!!data && data !== "") {
                return this.formatSelectType(this.parameters, data, 'MP_SHIP_SUPPLIES_TO')
            }
            return '-';
        },
        formatSquareFootCount: function (data) {
            if (!!data && data !== "") {
                return this.formatSelectType(this.parameters, data, 'MP_SQUARE_FOOT_COUNT')
            }
            return '-';
        },
        formatStatementDeliveryMethod: function (data) {
            if (!!data && data !== "") {
                return this.formatSelectType(this.parameters, data, 'MP_STATEMENT_DELIVERY_METHOD')
            }
            return '-';
        },
        formatStatementType: function (data) {
            if (!!data && data !== "") {
                return this.formatSelectType(this.parameters, data, 'MP_STATEMENT_TYPE')
            }
            return '-';
        },
        formatClientRegion: function (data) {
            if (!!data && data !== "") {
                return this.formatSelectType(this.parameters, data, 'FD_CLIENT_REGION_PARAM')
            }
            return '-';
        },

        // formatTerminalApplicationType: function (data) {
        //     if (!!data && data !== "") {
        //         return this.formatSelectType(this.parameters, data, 'MP_TERMINAL_APPLICATION_TYPE')
        //     }
        //     return '-';
        // },
        // formatTerminalNetworkName: function (data) {
        //     if (!!data && data !== "") {
        //         return this.formatSelectType(this.parameters, data, 'MP_TERMINAL_NETWORK_NAME')
        //     }
        //     return '-';
        // },
        // formatTraining: function (data) {
        //     if (!!data && data !== "") {
        //         return this.formatSelectType(this.parameters, data, 'MP_TRAINING')
        //     }
        //     return '-';
        // },
        // formatTransactionProcessMode: function (data) {
        //     if (!!data && data !== "") {
        //         return this.formatSelectType(this.parameters, data, 'MP_TRANSACTION_PROCESS_MODE')
        //     }
        //     return '-';
        // },
        // formatTransarmorEncryption: function (data) {
        //     if (!!data && data !== "") {
        //         return this.formatSelectType(this.parameters, data, 'MP_TRANSARMOR_ENCRYPTION')
        //     }
        //     return '-';
        // },
        // formatTransarmorHierarchy: function (data) {
        //     if (!!data && data !== "") {
        //         return this.formatSelectType(this.parameters, data, 'MP_TRANSARMOR_HIERARCHY')
        //     }
        //     return '-';
        // },
        // formatTransarmorServiceType: function (data) {
        //     if (!!data && data !== "") {
        //         return this.formatSelectType(this.parameters, data, 'MP_TRANSARMOR_SERVICE_TYPE')
        //     }
        //     return '-';
        // },
        // formatTransarmorTokenType: function (data) {
        //     if (!!data && data !== "") {
        //         return this.formatSelectType(this.parameters, data, 'MP_TRANSARMOR_TOKEN_TYPE')
        //     }
        //     return '-';
        // },
        formatCleanPhoneNumber: function (data) {
            if (!!data && data !== "") {
                return data.includes('undefined') || data === '+' ? '-' : data;
            }
            return '-';
        },
        formatCurrencyNumber(x, absolute = false, currency = 'USD') {
            let currency_code  = !!this.$route.params.currency ? this.$route.params.currency : currency;
            if(isNaN(parseInt(x))) {
                // return '';
                x = 0;
            }
            let number = Number.parseFloat(x);
            if(x < 0 && absolute === false){
                number = -number;
                return '-' + new Intl.NumberFormat(this.date_format, {style: 'currency', currency: currency_code,  maximumFractionDigits: 2}).format(number);
            }else{
                number = Math.abs(number); //convert to absolute number if absolute is true or if number is greater than 0
            }
            return new Intl.NumberFormat(this.date_format, {style: 'currency', currency: currency_code,  maximumFractionDigits: 2}).format(number);
        },
        formatEcomPaymentText(param_type, key) {
            let item = this.parameters[param_type].find(f => f.value === key)
            if (item) {
                return item.text
            }
            return '-'
        },
        formatEcomPaymentMethods: function(data) {
            if (!!data && data !== "") {
                return this.formatViewValueMultiSelect(data, this.parameters['ECOM_PAYMENT_METHOD_OPTIONS']);
            } else {
                return '-';
            }
        },
        getPostCodeRules: function(rules = [], country_code = null, no_country= false) {
            if (!country_code) {
                country_code = this.baseCountryCode;
            }

            let result_rules = [];
            if (Array.isArray(rules) && rules.length > 0) {
                result_rules = result_rules.concat(rules);
            }

            // UnitedKingdom-826, Poland-616, Ireland-372
            // Norway-578, Germany-276, Austria-40, Switzerland-756, Sweden-752
            let country_allowed_numeric_rule = ['578', '276', '40', '756', '752'];

            if (no_country) {
                // Enforce no-country validation
                result_rules.push(['alpha_numeric_space_no_unicode']);
            } else if (country_allowed_numeric_rule.includes(country_code)) {
                // Enforce numeric only validation
                // Norway-578, Germany-276, Austria-40, Switzerland-756, Sweden-752
                result_rules.push('numeric');
            }
            return result_rules;
        },
        // getHierarchyBalancePopText: function () {
        //     // return ''
        //     return '<div><p><i class="fa fa-square" style="color: #545959 ;"></i> Hierarchy Balance only</p>' +
        //         '<p><i class="fa fa-square" style="color: #D43900;"></i> Hierarchy and Actual Balance only</p>' +
        //         '<p><i class="fa fa-square" style="color: #004165 ;"></i> Actual Balance only</p> </div>'
        // },
        // getBalanceColour: function (account, key) {
        //     let balance = 0, info_balance = 0;
        //     if (key === 'prev') { //do prev balance
        //         balance = account.prev_balance;
        //         info_balance = account.info_prev_balance;
        //
        //     } else { //do balance
        //         balance = account.balance;
        //         info_balance = account.info_balance;
        //     }
        //
        //     if (balance != info_balance && balance != 0) {
        //         return 'mixed-balance'
        //     }
        //     if (info_balance != 0 && balance == 0) {
        //         return "info-balance"
        //     }
        //     return '';
        // },
    }

}